export const EDIT_UNIT_DEFAULT_FORM_VALUES = {
    callSign: null,
    dispatchArea: null,
    beatSubdivision: null,
    equipment: [],
    primaryUnitType: null,
    secondaryUnitTypes: [],
    station: null,
    unitId: null,
    vehicleTag: null,
    shiftNotes: '',
    shiftStart: '',
    shiftEnd: '',
    personnel: [],
    staffCount: undefined,
};
